import moment from "moment"
const newModel = () => {
    return {
        id: null,
        operatingCenterName: null,
        operatingCenterLogo: null,
        isChangedImage: null,
        localImage: null,
        localImageUrl: null,
        workspaceName: null,
        workspaceType: null,
        isDeleted: null,
        isUsePBIHome: null,
        reportId: null,
        createdAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss'),
        createdBy: null,
        updatedAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss'),
        updatedBy: null
    }
}

export const workspaceModel = {
    newModel
}
